import { motion } from 'framer-motion';
import { XCircle, CheckCircle } from 'lucide-react';

export const ProblemSolution = () => {
  const problems = [
    '80% of leads go unanswered within the first hour',
    'Missed appointments = lost revenue',
    'Customer service bottlenecks slow down growth',
    'Manual data entry wastes valuable time'
  ];

  const solutions = [
    'Instant customer support, 24/7 AI assistants',
    'Automated appointment setters & lead generation',
    'Seamless WhatsApp, email, and voice call integration',
    'Smart automation eliminates repetitive tasks'
  ];

  return (
    <section className="py-20 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.h2
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
          className="text-3xl font-bold text-center mb-16 text-cyan-400 neon-text"
        >
          Why AI Automation?
        </motion.h2>

        <div className="grid md:grid-cols-2 gap-12 md:gap-8">
          {/* Problems Section */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="space-y-8"
          >
            <div className="service-card p-6">
              <h3 className="text-xl font-semibold mb-6 text-red-500 flex items-center gap-2">
                <XCircle className="w-6 h-6" />
                Without AI Automation
              </h3>
              <ul className="space-y-4">
                {problems.map((problem, index) => (
                  <li key={index} className="flex items-start gap-2 text-gray-400">
                    <span className="text-red-500 opacity-75">✗</span>
                    {problem}
                  </li>
                ))}
              </ul>
            </div>
          </motion.div>

          {/* Solutions Section */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="space-y-8"
          >
            <div className="service-card p-6">
              <h3 className="text-xl font-semibold mb-6 text-cyan-400 flex items-center gap-2">
                <CheckCircle className="w-6 h-6" />
                With HyperMesh AI
              </h3>
              <ul className="space-y-4">
                {solutions.map((solution, index) => (
                  <li key={index} className="flex items-start gap-2 text-gray-400">
                    <span className="text-cyan-400 opacity-75">✓</span>
                    {solution}
                  </li>
                ))}
              </ul>
            </div>
          </motion.div>
        </div>

        {/* CTA Button */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
          className="text-center mt-12"
        >
          <a
            href="#case-studies"
            className="cta-button inline-flex items-center gap-2 text-lg font-semibold"
          >
            See AI in Action →
          </a>
        </motion.div>
      </div>
    </section>
  );
};